import React from 'react';
import {
  DateToShortReadableDate,
  FormatAsCurrencyForLocale
} from '@PetSureAustralia/petsure-react-ui-library/distLib/helpers';
import { InputCheckbox } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import PropTypes from 'prop-types';
import { CSPUrlsMap } from '../../../routes/CSPUrlsMap';
import { PremiumInstallmentPropTypes } from '../../../propTypes/outstandingPayment';

export const InstalmentRecord = ({ instalmentRecord, petIndex, errorRows, handleSelect, isPaynowEnabled }) => {
  return instalmentRecord?.map((installment, installmentIndex) => {
    const { FullPolicyNumber, InstalmentLineNumber, OriginalDueDate, DueAmount, isSelected, isValid } = installment;

    return (
      <React.Fragment key={`${FullPolicyNumber}_${InstalmentLineNumber}_fragment`}>
        <tr className={!isValid ? 'invalid' : ''}>
          {isPaynowEnabled && (
            <td>
              <fieldset>
                <InputCheckbox
                  name={`${FullPolicyNumber}_${InstalmentLineNumber}`}
                  onChange={() => {}}
                  disabled={!isValid}
                  customChangeHandler={() => handleSelect(installmentIndex, petIndex)}
                  checked={isSelected}
                />
              </fieldset>
            </td>
          )}

          <td>{DateToShortReadableDate(new Date(OriginalDueDate))}</td>
          <td>Missed Payment</td>
          <td>{FormatAsCurrencyForLocale(DueAmount)}</td>
        </tr>
        {Object.keys(errorRows).some((key) => key.startsWith(`${petIndex}-${installmentIndex}`)) && (
          <tr className="invalid invalid_message">
            <td colSpan="4">{errorRows[`${petIndex}-${installmentIndex}`]}</td>
          </tr>
        )}
        {!isValid && (
          <tr className="invalid invalid_message">
            <td colSpan="4">
              Please note, if you have only just made a payment it can take up to 20 minutes to process and for the
              payment to be reflected in the portal. Should you need further assistance,{' '}
              <a
                rel="noreferrer"
                href={`${CSPUrlsMap.contactUs.url}`}
              >
                contact us
              </a>
              .
            </td>
          </tr>
        )}
      </React.Fragment>
    );
  });
};

InstalmentRecord.propTypes = {
  instalmentRecord: PropTypes.arrayOf(PremiumInstallmentPropTypes),
  errorRows: PropTypes.objectOf(PropTypes.string),
  handleSelect: PropTypes.func,
  petIndex: PropTypes.number,
  isPaynowEnabled: PropTypes.bool
};
